const styles = {
  modal: {
    position      : 'absolute' as const,
    top           : '50%',
    left          : '50%',
    transform     : 'translate(-50%, -50%)',
    bgcolor       : 'background.paper',
    boxShadow     : 24,
    padding       : '1.5rem',
    display       : 'flex',
    alignItems    : 'center',
    justifyContent: 'center',
    maxWidth      : '1280px',
    maxHeight     : '80vh',
    overflowY     : 'auto',
  },
  title: {
    color: '#154A8A',
    fontWeight: 'bold',
    marginRight: 'auto',
  },
  stepperContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  mappingContainer: {
    width: '100%',
    display: 'flex'
  }
};
export default styles;